import { render, staticRenderFns } from "./WindShieldConfigurator.vue?vue&type=template&id=1dac7bb8&"
import script from "./WindShieldConfigurator.vue?vue&type=script&lang=js&"
export * from "./WindShieldConfigurator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports